module.exports = __webpack_public_path__ + "static/media/step3.08305ad0.png";